<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-3 my-5">
                <img width="300" src="../assets/health-here-logo.svg"/>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="alert alert-info col-3" role="alert" v-show="message">
                <div>{{ message }}</div>
            </div>
            <div class="alert alert-danger col-3" role="alert" v-show="errors.length > 0">
                <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <form class="form-horizontal">
                    <div class="form-group">
                        <label for="inputEmail3" class="control-label">Email</label>
                        <div class="">
                            <input type="email" v-model="credentials.email" class="form-control" id="inputEmail3"
                                   placeholder="Email">
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputPassword3" class="control-label">Password</label>
                        <div class="">
                            <input type="password" v-model="credentials.password" class="form-control"
                                   id="inputPassword3" placeholder="Password">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="">
                            <button type="submit" @click.prevent="submit()" class="btn btn-outline-orange">Sign in
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-3">
                <a href="#" @click.prevent="showForgotPassword()">Forget your password?</a>
            </div>
        </div>
    </div>
</template>

<script>
  import api from '../services/api'

  export default {
    name: 'login',

    props: {
      nextPath: {
        type: String,
        default: '/'
      }
    },

    data () {
      return {
        showLogin: false,
        credentials: {
          email: '',
          password: ''
        },
        errors: [],
        message: this.$route.query.message
      }
    },

    methods: {
      submit () {
        this.errors = []
        this.message = ''
        const credentials = {
          email: this.credentials.email,
          password: this.credentials.password
        }

        api.post('/Auth/Login', credentials).then(response => {
          const data = response.data

          if (!data.organizationId) {
            this.errors = ['This user is not configured for an organization']
          } else {
            const userRoles = data.roles.filter(role => role === 'Admin' || role === 'OrganizationUser' || role === 'OrganizationAdmin' || role === 'OrganizationPayee' || role === 'OrganizationEmployerUser')

            if (userRoles && userRoles.length > 0) {
              this.$store.userAuthenticated(data, null, () => {
                let path = this.nextPath
                if (path === '/logout') {
                  path = '/'
                }
                if (path === '/') {
                  path = this.$store.homePagePath
                }
                this.$router.push(path)
              })
            } else {
              this.errors = ['This user does not have the appropriate roles to access the dashboard']
            }
          }
        }, errorResponse => {
          if (errorResponse.response) {
            this.errors = errorResponse.response.data.login_failure
          } else {
            this.errors = [errorResponse.message]
          }
          this.$store.logoutUser()
        })

      },

      showForgotPassword () {
        this.$router.push({ path: 'forgot-password', query: { email: this.credentials.email } })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
